"use strict";

import Swiper from 'swiper/bundle';


const setCarousel = () => {
  const sliderThumbnail = new Swiper(".officegallery-carousel__thumbnail", {
    slidesPerView: 3,
    spaceBetween: 12,
    loop: true,
    loopedSlides: 8,
    speed: 500,
    autoplay: {
      delay: 5500,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 4,
        spaceBetween: 16,
      }
    }
  });

  const slider = new Swiper(".officegallery-carousel__main", {
    loop: true,
    effect: "fade",
    loopedSlides: 8,
    thumbs: {
      swiper: sliderThumbnail,
    },
  });

  sliderThumbnail.on('slideChange', () => {
    slider.slideTo(sliderThumbnail.activeIndex);
  });
}

window.addEventListener(
  'load',
  () => {
    setCarousel();
  }
);